// Color palette

export const cornflowerblue = '#3D71C6'
export const lightgreen = '#84D7D7'
export const darkgray = '#ACACAC'
export const darkslategray = '#283750'
export const lavendergray = '#E4EAEE'
export const lightseagreen = '#319E9B'
export const sandybrown = '#EABE3B'
export const skyblue = '#86D7D7'
export const lightblue = '#E3EEFF'
export const slategray = '#9ca3ae'
export const tomato = '#EF5048'
export const white = '#FFFFFF'
